import React, { useEffect,useState,memo } from 'react';
// import { connect } from 'react-redux';
import Icons from "../../Icons/Icons";
// import {parameterizedURLAccessToken} from '../../../Utils/CommonFunctions';
import { withRouter } from 'react-router';
import { parameterizedURLAccessToken } from '../../../Utils/CommonFunctions';
import isEqual from 'lodash/isEqual';

const Profile = props => {
	const userInfo = props.userInfo;
	const [imageSrc, setImageSrc] = useState('');
	useEffect(()=>{
		if(userInfo && userInfo.data) {
			const img = parameterizedURLAccessToken('files/download?fileId='+userInfo.data.profile_avatar)
			setImageSrc(img);	
		}
	},[props.userInfo])

	

	let user_name = '';
	let profile_name = '';
	let role_name = '';
	let profile_avatar = '';
	
	if(userInfo && userInfo.data) {
		user_name = userInfo.data.first_name + ' ' + userInfo.data.last_name;
		profile_name = userInfo.data.profile_name;
		role_name = userInfo.data.role_name;
		profile_avatar = userInfo.data.profile_avatar;	
	}

	
    const fallbackImage = '/assets/img/profile2.jpg'; // Replace with your fallback image URL

    const handleImageError = (e) => {
        // console.log("Image does not exist or failed to load.");
        setImageSrc(fallbackImage); // Set the fallback image
    };

    const handleImageLoad = () => {
        // console.log("Image exists and loaded successfully.");
    };
	

	const logout = () => {
		props.onAuthenticateHandler();
		props.history.push("/login");
	}
	return (
		<ul className="dropdown-menu dropdown-user animated fadeIn p-0">
			<div className="dropdown-user-scroll scrollbar-outer">
				<li className="smoky_light_bg d-flex align-items-center justify-content-between">
					<div className="avatar-inner position-relative" style={{"top":"0px"}}>
					{
						profile_avatar && profile_avatar !== 'null' && profile_avatar!=='' ?
							<img src={imageSrc}
								onError={handleImageError}
								onLoad={handleImageLoad}
 								alt="image profile" 
								className="avatar-img rounded" style={{width:'100px'}}/>
						: <Icons iconType="Profile" />
					}
					</div>
					<div className="profile-box">
						
						<div className="u-text" style={{"width":"220px","float":"right","display":"grid"}}>
							<h4 className="secondary_color text-truncate" title={user_name}>{user_name}</h4>
							<p className="third_light_color mb-0 text-truncate" title={role_name}>{role_name}</p>	
						</div>
						
					</div>
					<div className="dropdown-divider m-0"></div>
				</li>
				<li className="profile-list">
					{/* <a href="#">
						<div className="navi-link svgIconFill">
							<div className="mr-3 w-px-20">
								<span className="">
									<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="22px" height="22px" viewBox="0 0 26 26" enableBackground="new 0 0 26 26">
										<g>
											<path fill="#B0BEC5" d="M18.581,6.222c-0.615,0-1.117-0.449-1.117-1.002V2.412c0-0.553,0.502-1.002,1.117-1.002 s1.116,0.449,1.116,1.002V5.22C19.697,5.772,19.196,6.222,18.581,6.222z"/>
											<path fill="#B0BEC5" d="M7.42,6.222c-0.616,0-1.116-0.449-1.116-1.002V2.412c0-0.553,0.5-1.002,1.116-1.002 c0.616,0,1.115,0.449,1.115,1.002V5.22C8.535,5.772,8.036,6.222,7.42,6.222z"/>
											<path fill="#B0BEC5" d="M20.145,25.069H5.857c-2.587-0.001-4.685-1.887-4.687-4.212V8.427c0.002-2.324,2.1-4.208,4.687-4.21 h14.287c2.585,0.001,4.685,1.886,4.686,4.21v12.431C24.829,23.183,22.729,25.068,20.145,25.069z M5.857,6.222 C4.503,6.224,3.404,7.21,3.403,8.427v12.431c0.001,1.221,1.101,2.204,2.455,2.206h14.287c1.353-0.002,2.45-0.985,2.452-2.206 V8.427c-0.002-1.217-1.1-2.203-2.452-2.205H5.857z"/>
											<path fill="#B0BEC5" d="M23.714,11.434H2.287c-0.617,0-1.116-0.449-1.116-1.002c0-0.555,0.5-1.003,1.116-1.003h21.427 c0.614,0,1.116,0.449,1.116,1.003C24.83,10.985,24.328,11.434,23.714,11.434z"/>
											<path fill="#B0BEC5" fillOpacity="0.5" d="M16.571,18.289H9.429c-0.617,0-1.117-0.449-1.117-1.002 c0-0.555,0.5-1.005,1.117-1.005h7.142c0.616,0,1.118,0.45,1.118,1.005C17.689,17.84,17.188,18.289,16.571,18.289z"/>
											<path fill="#B0BEC5" fillOpacity="0.5" d="M13,21.498c-0.617,0-1.116-0.45-1.116-1.005v-6.415c0-0.556,0.499-1.003,1.116-1.003 s1.117,0.448,1.117,1.003v6.415C14.117,21.048,13.617,21.498,13,21.498z"/>		 
										</g>
									</svg>
								</span>
							
							</div>
							<div className="navi-text">
								<div className="">Tasks</div>
								<div className="text-medium">
									Latest task and more 
								</div>
							</div>
							<i className="fas fa-chevron-right text-small"></i>
						</div>
					</a>  */}

					{/* <a href="#">
						<div className="navi-link">
							<div className="mr-3 w-px-20">
								<span className="">
									<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="22px" height="22px" viewBox="0 0 22 22" enableBackground="new 0 0 22 22">
										<g>
											<path fill="#B0BEC5" d="M15.279,21.521H6.72c-2.067-0.002-3.743-1.678-3.745-3.745V6.72C2.978,4.653,4.653,2.978,6.72,2.976 h8.559c2.068,0.002,3.743,1.677,3.745,3.745v11.056C19.022,19.844,17.348,21.52,15.279,21.521z M6.72,4.759 C5.638,4.761,4.761,5.638,4.759,6.72v11.056c0.002,1.083,0.879,1.96,1.961,1.962h8.559c1.083-0.002,1.96-0.879,1.962-1.962V6.72 c-0.002-1.083-0.879-1.959-1.962-1.961H6.72z"/>
											<path fill="#B0BEC5" d="M13.497,3.867c0-1.379-1.118-2.497-2.497-2.497c-1.378,0-2.497,1.118-2.497,2.497H13.497z"/>
											<path fill="#B0BEC5" d="M13.497,3.867c0-1.379-1.118-2.497-2.497-2.497c-1.378,0-2.497,1.118-2.497,2.497H13.497z"/><path fill="#B0BEC5" d="M13.497,4.759H8.503c-0.492,0-0.892-0.399-0.892-0.892c0-1.871,1.517-3.388,3.388-3.388 c1.872,0,3.389,1.517,3.389,3.388C14.389,4.359,13.989,4.759,13.497,4.759z M9.666,2.976h2.668 c-0.493-0.737-1.49-0.935-2.227-0.441C9.933,2.651,9.783,2.801,9.666,2.976z"/>
											<circle fill="#B0BEC5" cx="11" cy="2.975" r="0.892"/>
											<path fill="#B0BEC5" fillOpacity="0.5" d="M10.059,15.661c-0.236,0-0.463-0.094-0.631-0.26l-2.446-2.439 c-0.354-0.343-0.363-0.907-0.02-1.261c0.342-0.354,0.907-0.363,1.26-0.02c0.007,0.006,0.015,0.014,0.022,0.021l1.815,1.816 l3.698-3.71c0.349-0.348,0.914-0.348,1.263,0c0.348,0.349,0.348,0.914,0,1.263l-4.33,4.33 C10.522,15.567,10.295,15.661,10.059,15.661z"/>
											 
										</g>
									</svg>
								</span>
							</div>
							<div className="navi-text">
								<div className="">Tickets</div>
								<div className="text-medium">Issues and more 
								</div>
							</div>
							<i className="fas fa-chevron-right text-small"></i>
						</div>
					</a>  */}
					{/* <a href="#">
						<div className="navi-link">
							<div className="mr-3 w-px-20">
								<span className=""> 
									<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="22px" height="22px" viewBox="0 0 22 22" enableBackground="new 0 0 22 22">
									 	<g>
											<path fill="#B0BEC5" d="M18.084,20.509H3.915C1.753,20.507,0.002,18.755,0,16.593V5.406c0.002-2.161,1.753-3.913,3.915-3.915 h14.169C20.246,1.493,21.998,3.245,22,5.406v11.187C21.998,18.755,20.246,20.507,18.084,20.509z M3.915,3.356 c-1.131,0.002-2.049,0.919-2.051,2.05v11.187c0.002,1.132,0.919,2.05,2.051,2.051h14.169c1.133-0.001,2.05-0.919,2.052-2.051 V5.406c-0.002-1.131-0.919-2.048-2.052-2.05H3.915z"/>
											<path fill="#B0BEC5" fillOpacity="0.5" d="M11,12.123c-0.672,0.001-1.334-0.17-1.92-0.501l-8.55-4.806 C0.081,6.563-0.078,5.994,0.175,5.545c0.254-0.449,0.823-0.608,1.272-0.354l0,0l8.546,4.81c0.625,0.347,1.385,0.347,2.01,0 l8.55-4.81c0.449-0.254,1.019-0.095,1.271,0.354s0.095,1.019-0.354,1.271l-8.55,4.806C12.334,11.953,11.672,12.124,11,12.123z"/>
										</g>
									</svg>
								</span>
							
							</div>
							<div className="navi-text">
								<div className="">Message</div>
								<div className="text-medium">Inbox and Tasks 
								</div>
							</div>
							<i className="fas fa-chevron-right text-small"></i>
						</div>
					</a> */}
					{/* <a href="#">
						<div className="navi-link">
							<div className="mr-3 w-px-20">
								<span className="">
									<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="22px" height="22px" viewBox="0 0 22 22" enableBackground="new 0 0 22 22">
										 
										<g>
											<circle opacity="0.5" fill="#B0BEC5" cx="10.935" cy="5.314" r="3.682"/>
											<path fill="#B0BEC5" d="M19.848,17.484c-0.793-3.339-3.4-5.948-6.739-6.74c-4.879-1.154-9.767,1.864-10.922,6.74 c-0.169,0.717,0,1.233,0.459,1.811C3.117,19.891,3.837,20,4.599,20h12.835c0.761,0,1.479-0.109,1.95-0.705 C19.845,18.718,20.015,18.201,19.848,17.484z"/>
										</g>
									</svg>
								</span>
							</div>
							<div className="navi-text">
								<div className="">My Profile</div>
								<div className="text-medium">Account settings and more				 
								</div>
							</div>
							<i className="fas fa-chevron-right text-small"></i>
						</div>
					</a> */}

					<button className="btn btn-sm primary_bg signOut"   onClick={logout}>
						<i className="fas fa-sign-out-alt fa-lg"></i> Sign out
					</button>
				</li>
			</div>
		</ul>
	);
}

const isDiffProps = (prevProps,nextProps)=>{
	if(isEqual(prevProps.userInfo,nextProps.userInfo)){
	  return true;
	}
  }
export default withRouter(memo(Profile,isDiffProps));